import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Particles } from '../components/Particles';
import { authApi } from '../lib/api';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' | 'info' } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const showMessage = (text: string, type: 'success' | 'error' | 'info') => {
    setMessage({ text, type });
    if (type !== 'success') {
      setTimeout(() => setMessage(null), 6000);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!email) {
      showMessage('Por favor, insira seu email.', 'error');
      return;
    }

    setIsLoading(true);

    try {
      await authApi.forgotPassword(email);

      // Email enviado com sucesso
      showMessage(
        '✅ Email enviado! Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.',
        'success'
      );

      setEmailSent(true);

      // Limpar formulário
      setEmail('');

      // Opcional: redirecionar após alguns segundos
      setTimeout(() => {
        showMessage('Você será redirecionado para a página de login em 5 segundos...', 'info');
      }, 3000);

      setTimeout(() => {
        window.location.href = '/login?message=check_email';
      }, 8000);
    } catch (error: any) {
      console.error('Erro ao solicitar recuperação:', error);

      let errorMessage = 'Erro ao enviar email. Tente novamente.';

      if (error?.response?.status === 404) {
        // Por segurança, não informar que o usuário não existe
        errorMessage = 'Se este email estiver cadastrado, você receberá as instruções de recuperação.';
      } else if (error?.response?.status === 429) {
        errorMessage = 'Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.';
      } else if (error?.response?.status === 400) {
        errorMessage = 'Email inválido. Por favor, verifique e tente novamente.';
      } else if (!error?.response) {
        errorMessage = 'Não foi possível conectar ao servidor. Verifique sua conexão.';
      }

      showMessage(errorMessage, 'error');
      setIsLoading(false);
    }
  };

  return (
    <>
      <Particles />

      <div className="auth-container">
        {/* Voltar */}
        <Link to="/login" className="back-link">
          ← Voltar para login
        </Link>

        {/* Logo */}
        <div className="auth-logo">
          <img src="/images/logo/logo.png" alt="NeuroAtleta Mindset" />
          <h1>Recuperar Senha</h1>
          <p>Insira seu email para receber instruções de recuperação</p>
        </div>

        {/* Mensagens */}
        {message && (
          <div id="message-container">
            <div className={`message ${message.type}`}>{message.text}</div>
          </div>
        )}

        {/* Formulário de Recuperação */}
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
            <span className="error-message">Email inválido</span>
          </div>

          <button type="submit" className="btn-primary" disabled={isLoading || emailSent}>
            {isLoading ? (
              <>
                <span className="spinner"></span> Enviando...
              </>
            ) : emailSent ? (
              'Email Enviado!'
            ) : (
              'Enviar Link de Recuperação'
            )}
          </button>
        </form>

        {/* Informação adicional */}
        <div className="info-box">
          <strong>💡 Dica:</strong> Verifique sua caixa de spam se não receber o email em alguns minutos.
        </div>

        {/* Links */}
        <div className="auth-links">
          <div className="divider">
            <span>ou</span>
          </div>
          <Link to="/register" className="auth-link">
            Não tem uma conta? <strong>Criar conta</strong>
          </Link>
        </div>
      </div>
    </>
  );
}
